// @ts-check

/**
 * @typedef {Object} ConvertAddressesReturnType
 * @property {string} address_id
 * @property {string} type
 * @property {string} street
 * @property {string} city
 * @property {string} province
 * @property {string} country
 * @property {string} postalCode
 * @property {string} placeId
 * @property {string} lat
 * @property {string} lng
 */

/**
 * @function convertAddresses
 * @param {ProfileAddress[]} addresses
 * @param {Object[]} addressIds
 * @param {string} addressIds.address_id
 * @param {string} addressIds.address_type_id
 * @returns {ConvertAddressesReturnType[]}
 */
function convertAddresses(addresses, addressIds) {
	const addressTypes = ['4', '5', '6'];

	const addressesMap = new Map(addresses.map((address) => [address.address_id, address]));

	const addressIdsMap = new Map(addressIds.map((addrId) => [addrId.address_type_id, addrId]));

	return addressTypes.map((type) => {
		let newAddressObj = {
			address_id: '',
			type: type,
			street: '',
			city: '',
			province: '',
			country: '',
			postalCode: '',
			placeId: '',
			lat: '',
			lng: '',
			unit: '',
		};

		const addressIdObj = addressIdsMap.get(type);

		if (addressIdObj) {
			const addrId = addressIdObj.address_id;
			const address = addressesMap.get(addrId);

			if (address) {
				const [street = '', unit = ''] = address.line1.split(',');

				Object.assign(newAddressObj, {
					address_id: addrId,
					street: `${street.trim()}, ${unit.trim()}`,
					unit: unit.trim(),
					city: address.city,
					province: address.province,
					country: address.country,
					postalCode: address.postal_code,
					placeId: address.place_id,
					lat: address.lat,
					lng: address.lng,
				});
			}
		}

		return newAddressObj;
	});
}

export default convertAddresses;
